<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddAir"
    :before-close="doClose"
    width="60%"
    top="5vh"
  >
    <el-form :ref="refForm" :rules="rules" :model="airform" label-width="200px">
      <el-form-item :label="$t('desc.customerName')" prop="customerId">
        <el-select
          v-model="airform.customerId"
          filterable
          :placeholder="$t('desc.select')"
          style="width: 100%"
          @change="custChanged"
        >
          <el-option
            v-for="item in custOption"
            :key="item.id"
            :label="item.customerName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('desc.airCompressionStation')"
        prop="stationName"
      >
        <el-input v-model="airform.stationName" style="width: 280px"></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('title.airCompressionStationAddress')"
        prop="address"
      >
        <el-input
          v-model="airform.address"
          style="width: 280px"
        ></el-input>
      </el-form-item>


      <!-- <el-form-item label="空压机">
        <el-table
          :data="DeviceTable"
          ref="DeviceTable"
          stripe
          style="width: 722px"
        >
          <el-table-column :label="$t('title.operate')" width="52px">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-delete"
                circle
                size="mini"
                type="danger"
                @click="delBuildRow(scope.$index, scope.row)"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column label="选择空压机" min-width="35%">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.ssn"
                :placeholder="$t('desc.select')"
              >
                <el-option
                  v-for="(item, index) in DeviceList"
                  :key="index"
                  :label="item.ssn"
                  :value="item.ssn"
                  >{{ item.name }}
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          class="el-icon-plus"
          @click.prevent="addBuildRow()"
        ></el-button>
      </el-form-item> -->
      <el-form-item style="margin-left: 120px">
        <el-button v-if="subButtonAuth" type="success" @click="onSubBtn(refForm)">{{$t("button.confirm")}}</el-button>
        <el-button @click="doClose">{{$t("button.cancel")}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "index",
  props: {
    subButtonAuth: false,
    refForm: "",
    title: "",
    dialogAddAir: false,
    airform: {
      stationName: {
        type: String,
        required: true,
      },
      address: "",
      customerName: "",
      customerId: "",
    //   DeviceTable: {
    //     type: Array,
    //     default: function () {
    //       return [];
    //     },
    //   },
    },
    custOption: {
      type: Array,
      default: function () {
        return [];
      },
    },
    airoptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("tips.needed")));
      }
    };
    return {
      rules: {
        stationName: [{ required: true, message: this.$t("tips.needed"), trigger: "blur" }],
        customerId: [{ required: true, message: this.$t("tips.needed"), trigger: ['blur','change'] }],
      },
    };
  },
  methods: {
    custChanged(value) {

    },
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      var ref = this.refForm;
      this.$refs[ref].resetFields();
    },
    addBuildRow() {
      this.$emit("addBuildRow", true);
    },
    //产品大类 删除
    delBuildRow(index, row) {
      this.$emit("delBuildRow", index, row);
    },
  },
};
</script>

<style>
</style>
